import { cn } from "tools/ui";
import { ChevronDownIcon } from "components/Icons";

export function SelectField({
  name,
  options,
  placeholder,
  className,
  disabled,
  value,
  onChange,
  required,
  ...props
}) {
  return (
    <div className="relative">
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        className={cn(
          "appearance-none w-fit cursor-pointer pl-4 pr-8 py-1",
          className,
        )}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option
            key={opt.value}
            value={opt.value}
            className={cn(
              "focus:bg-blue-400 text-black focus:text-black hover:bg-blue-400 hover:text-black",
              opt.value == value && "bg-amber-100",
            )}
          >
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-2 top-1.5 pointer-events-none z-10 w-5 fill-current" />
    </div>
  );
}

export default SelectField;
